import { Header } from "@/components";
import Footer from "../../components/common/layout/Footer";
import BlogDetail from "@/components/detail/BlogDetailPage";

export default function BlogDetailPage() {
    return(
        <div>
            <Header />
            <BlogDetail />
            <Footer />
        </div>
    )
}